import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { AccountService } from "../../../../../app/service/finzy-flex/account/account.service";
import { Toaster, Type } from "../../../../../app/toaster/Toaster";
import { WithdrawalRequestsData } from "../../../../../app/model/finzy-flex/withdraw-request.model";
import { Router } from "@angular/router";
@Component({
  selector: 'app-confirm-withdrawal-popup',
  templateUrl: './confirm-withdrawal-popup.component.html',
  styleUrls: ['./confirm-withdrawal-popup.component.css']
})
export class ConfirmWithdrawalPopupCompoenent implements OnInit {
  withdrawalRequestForm: FormGroup
  withdrawalRequests: WithdrawalRequestsData[];
  getTotalWithdrawalAmount: number;
  withdrawalRequestInProgress: boolean = false;
  constructor(private accountService: AccountService,
    private matDialogRef: MatDialogRef<ConfirmWithdrawalPopupCompoenent>, private router: Router,
    @Inject(MAT_DIALOG_DATA) data: { withdrawalRequestForm: FormGroup, withdrawalRequests: any, getTotalWithdrawalAmount: number }) {
    this.withdrawalRequestForm = data.withdrawalRequestForm;
    this.withdrawalRequests = data.withdrawalRequests.value;
    this.getTotalWithdrawalAmount = data.getTotalWithdrawalAmount;
  }
  ngOnInit(): void { }

  onMayBeLater() {
    this.matDialogRef.close(true);
    this.router.navigate(['/finzy-flex/dashboard']);
  }

  async onConfirmWithdrawal() {
    this.withdrawalRequestInProgress = true;
    let request = this.withdrawalRequestForm?.value;
    if (request && request.withdrawalRequests) {
      request.withdrawalRequests = request?.withdrawalRequests?.filter(req => req?.withdrawalAmount >= 1);
    }
    this.accountService.withdrawMoney(request).then((data) => {
      if (data && data.errors) {
        Toaster.toast(`Something went wrong while processing your withdrawal request`, Type.Error);
      } else {
        Toaster.toast(`Your withdrawal request processed successfully`, Type.Success);
      }
    }).catch((error) => {
      Toaster.toast(`Something went wrong while processing your withdrawal request`, Type.Error);
      this.matDialogRef.close(true);
    }).finally(() => {
      this.router.navigate(['/finzy-flex/dashboard']).then((res) => {
        this.withdrawalRequestInProgress = false;
        this.matDialogRef.close(true);
      });
    });
  }
}